const getDispatchCountingState = ({ dispatched_quantity, quantity }) => {
  if (!dispatched_quantity) return "pending";
  if (dispatched_quantity > quantity) return "over";
  if (dispatched_quantity < quantity) return "under";
  return "correct";
};

export default getDispatchCountingState;